import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface GenSingleImageUrlModel extends BaseModel {
  variables?: { [key: string]: string } | GenSingleImageUrlVariables;
}

export interface GenSingleImageUrlVariables {
  Link: string;
}

export class GenSingleImageUrlInitVariables implements GenSingleImageUrlVariables {
  Link = '';
}

export class GenSingleImageUrlInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new GenSingleImageUrlInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
